import { Outlet } from 'react-router-dom';

export default function MerchantSubmerchants() {
    return (
        <Outlet />
    )
}
